import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Container = styled.ul`
    display: grid;
    grid-auto-flow: row;
    padding: 0;
    row-gap: 16px;

    ${MediaQuery.xLarge(css`
        height: 100%;
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: max-content;
        column-gap: 40px;
        margin: 0;
        padding-left: 64px;        
    `)};
`;

export const Tooltip = styled.ul`
    padding: 4px 16px 32px 8px;
    grid-auto-flow: row;
    grid-auto-rows: min-content;
    row-gap: 16px;
    width: 100%;

    ${MediaQuery.xLarge`
        width: max-content;
        position: absolute;
        top: 100%;
        left: -40px;
        padding: 24px 40px;
        z-index: 1;
        display: none;
        background-color: ${colors.WHITE};
        border-radius: 0 0 4px 4px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    `};
`;

export const SubNavigationItem = styled.li`
    list-style: none;
    display: flex;

    a {
        width: 100%;
        color: #63666A;   
        font-weight: 500; 
        font-size: 16px;
    
        &:hover {
            color: ${colors.BLACK};
            text-decoration: none;
        }
    }

    ${MediaQuery.xLarge(css`
        a {
            font-size: 14px;

            &:hover {
                text-decoration: underline;
            }
        }
        `)
};
`;

export const ChevronContainer = styled.div`
    * {
        pointer-events: none;
    }

    display: flex;
    align-self: center;
    padding-bottom: 16px;
    padding-right: 12px;

     ${MediaQuery.xLarge(css`
        display: none;
    `)};   
`;

export const NavItemName = styled.div`
    display: flex;
    align-content: center;
    width: 100%;
    justify-content: space-between;

    >a, >p {
        text-decoration: none;
        font-size: 16px;
        font-weight: 600;
        color: ${colors.BLACK};
        margin: 0;
        line-height: 24px;
        padding-bottom: 16px;

        ${MediaQuery.xLarge(css`
            padding: 36px 2px 40px 2px;
        `)};
    }
`;

export const NavigationItem = styled.li`
    list-style: none;
    border-bottom: 1px solid #D9D9D6;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: end;
    box-sizing: border-box;

    ${ChevronContainer} {
        object {
            transform: ${({ $isOpen, $isActive }) => {
    if ($isOpen) return 'rotate(180deg)';
    if ($isActive) return 'rotate(90deg)';
    return 'rotate(0deg)';
  }};
        };
    }

    ${Tooltip} {
        display: ${({ $isOpen }) => ($isOpen ? 'grid' : 'none')};
        ${MediaQuery.xLarge(css`
            display: none;
        `)};
    }

    ${MediaQuery.xLarge`
        position: relative;
        border-bottom: none;
        border-top: 4px solid transparent;
        border-color: ${({ $isActive }) => ($isActive ? colors.BRAND_ORANGE : 'transparent')};
    `};

    &:hover, &:focus-within {
        cursor: pointer;

        >a, >p {
            text-decoration: none;
            color: ${colors.BLACK};

            ${MediaQuery.xLarge(css`
                color: #63666A;
            `)};
        }

        ${NavItemName} {
            >a, >p {
                text-decoration: none;
                color: ${colors.BLACK};

                ${MediaQuery.xLarge(css`
                    color: #63666A;
                `)};
            }
        }

        ${MediaQuery.xLarge`
            border-top-color: ${colors.BRAND_ORANGE};
        `};
        

        ${Tooltip} {
            display: ${({ $isOpen }) => ($isOpen ? 'grid' : 'none')};

            ${MediaQuery.xLarge(css`
                display: grid;
            `)};
        }
    }
    
    >a, >p {
        text-decoration: none;
        font-size: 16px;
        font-weight: 600;
        color: ${colors.BLACK};
        margin: 0;
        line-height: 24px;
        padding-bottom: 16px;

        ${MediaQuery.xLarge(css`
            padding: 36px 2px 40px 2px;
        `)};
    }
`;

export const SubNavigationGroup = styled.ul`
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    padding-left: 12px;
    padding-top: 16px;
    row-gap: 16px;

    ${MediaQuery.xLarge(css`
        row-gap: 12px;
    `)};
`;

export const SubNavigationGroupItem = styled.li`
    list-style: none;

    a {
        width: 100%;
        color: #63666A;
        font-size: 16px;
        font-weight: 500;

        &:hover {
            text-decoration: none;
            color: ${colors.BLACK};
        }        
    }

    ${MediaQuery.xLarge(css`
        a {
            font-size: 14px;

            &:hover {
                text-decoration: underline;
            }
        }    
    `)};
`;

export const SubNavItemName = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    object {
        width: 10px;
    }

    img {
        width: 10px;
    }
`;

export const SubNavigationGroupContainer = styled.li`
    list-style: none;
    width: 100%;
    color: ${colors.BLACK};

    p {
        font-weight: 500;
        margin: 0;
        font-size: 16px;
    }

    ${MediaQuery.xLarge(css`
        p {
            font-size: 14px;
        }    
    `)};

    ${SubNavItemName} {
        object {
            transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
        }
    }

    ${SubNavigationGroup} {
        display: ${({ $isOpen }) => ($isOpen ? 'grid' : 'none')};
    }
`;
